import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles(() => ({
  image: {
    width: 148,
    height: 148,
    borderRadius: 16,
    objectFit: 'cover' as const,
    display: 'block',
  },
  pdfPreview: {
    borderRadius: 16,
    height: 148,
    width: 148,
    overflow: 'hidden',
  },
  pdfIframe: {
    border: 'none',
    height: '100%',
    width: '100%',
  },
  pdfPlaceholder: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    backgroundColor: STYLE.COLOR.BACKGROUND_LIGHT,
    cursor: 'pointer',
  },
  pdfFallbackIcon: {
    width: 40,
    height: 48,
    marginTop: 18,
  },
  pdfLabel: {
    fontSize: '12px',
    fontWeight: 600,
    color: STYLE.COLOR.ACCENT_PRIMARY,
  },
}));
